import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import * as formationsSessionService from './formationsSession.service';

export const loadFormationSession = createAsyncThunk('formationsSession/load', async (userId) => formationsSessionService.getAllFormations(userId));
export const loadFormationSessionDemand = createAsyncThunk('formationsSessionDemand/load', async (userId) => formationsSessionService.getAllFormationsFromDemandPAge(userId));

export const getReservationList = createAsyncThunk('formationsSession/getReservationList', async (formationsSessionObject) => formationsSessionService.getReservationList(formationsSessionObject));

export const updateStatut = createAsyncThunk('formationsSession/updateStatut', async (statutObject) => formationsSessionService.updateStatut(statutObject));

export const updateFormationStatut = createAsyncThunk('formationsSession/updateFormationStatut', async (statutObject) => formationsSessionService.updateFormationStatut(statutObject));

export const archiveFormation = createAsyncThunk('formationsSession/archiveFormation', async (sessionIdObject) => formationsSessionService.archiveFormation(sessionIdObject));

export const formationsSessionSlice = createSlice({
  name: 'formationsSession',
  initialState: {
    objetcGetFromStatutUpdate: {},

    formationsSessionTab: [],
    formationsSessionTabDemand: [],

    reservationListTab: [],

    isGetingReservationList: false,
    getReservationListSuccess: false,

    isFormationsSessionLoad: false,
    isFormationsSessionLoading: false,

    isFormationsDemandSessionLoad: false,
    isFormationsDemandSessionLoading: false,

    isStatutUpdating: false,
    isStatutUpdatedSuccess: false,
    isStatutUpdatingError: false,

    isArchiveFormation: false,
    isArchiveFormationSuccess: false,

    isUnArchiveFormation: false,
    isUnArchiveFormationSuccess: false,

    isFormationStatutUpdating: false,
    isFormationStatutUpdatedSuccess: false,

    isLoading: false,
    error: '',
  },
  reducers: {
    initFormationsSession: (state, action) => {
      state.formationsSessionTab = [...action.payload];
    },
    initFormationsSessionReservation: (state, action) => {
      state.reservationListTab = [...action.payload];
    },

    initUpdatingStatut: (state, action) => {
      state.reservationListTab = [...action.payload];
    },

    resetData: (state) => {
      state.isFormationsSessionLoad = false;
      state.isFormationsSessionLoading = false;

      state.isFormationsDemandSessionLoad = false;
      state.isFormationsDemandSessionLoading = false;

      state.isStatutUpdating = false;
      state.isStatutUpdatedSuccess = false;

      state.isArchiveFormation = false;
      state.isArchiveFormationSuccess = false;

      state.isUnArchiveFormation = false;
      state.isUnArchiveFormationSuccess = false;

      state.isFormationStatutUpdating = false;
      state.isFormationStatutUpdatedSuccess = false;
      state.isLoading = false; // Optionnel : réinitialiser l'état de chargement si nécessaire
    },

    resetDataReservationList: (state) => {
      state.isGetingReservationList = false;
      state.getReservationListSuccess = false;
      state.reservationListTab = [];
    },
    resetDataUpdating: (state) => {
      state.isStatutUpdating = false;
      state.isStatutUpdatedSuccess = false;
      state.isStatutUpdatingError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadFormationSessionDemand.pending, (state) => {
        state.isFormationsDemandSessionLoading = true;
        state.isFormationsDemandSessionLoad = false;
      })
      .addCase(loadFormationSessionDemand.fulfilled, (state, action) => {
        state.isFormationsDemandSessionLoading = false;
        state.isFormationsDemandSessionLoad = true;
        state.formationsSessionTabDemand = [...action.payload.data];
      })
      .addCase(loadFormationSessionDemand.rejected, (state, action) => {
        state.isFormationsDemandSessionLoading = false;
        state.isFormationsDemandSessionLoad = false;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
      });

    builder
      .addCase(loadFormationSession.pending, (state) => {
        state.isFormationsSessionLoading = true;
        state.isFormationsSessionLoad = false;
      })
      .addCase(loadFormationSession.fulfilled, (state, action) => {
        state.isFormationsSessionLoading = false;
        state.isFormationsSessionLoad = true;
        state.formationsSessionTab = [...action.payload.data];
      })
      .addCase(loadFormationSession.rejected, (state, action) => {
        state.isFormationsSessionLoading = false;
        state.isFormationsSessionLoad = false;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
      });

    builder
      .addCase(getReservationList.pending, (state) => {
        state.isGetingReservationList = true;
        state.getReservationListSuccess = false;
        // console.log( 'suppression en cour:' );
      })
      .addCase(getReservationList.fulfilled, (state, action) => {
        state.isGetingReservationList = false;
        state.getReservationListSuccess = true;
        // console.log('data de reservation avant ', state.reservationListTab);

        state.reservationListTab = { ...action.payload.data };
        // console.log('data de reservation apres ', state.reservationListTab);
        // console.log( 'intervenant supprimer avec succès:', action.payload );
      })
      .addCase(getReservationList.rejected, (state, action) => {
        state.isGetingReservationList = false;
        state.getReservationListSuccess = false;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log( "Erreur lors de la supression de l'intervenant:", state.error );
      });

    builder
      .addCase(updateStatut.pending, (state) => {
        state.isStatutUpdating = true;
        state.isStatutUpdatingError = false;
        state.isStatutUpdatedSuccess = false;
      })
      .addCase(updateStatut.fulfilled, (state, action) => {
        state.isStatutUpdating = false;
        state.isStatutUpdatingError = false;
        state.isStatutUpdatedSuccess = true;
        state.objetcGetFromStatutUpdate = {
          ...state.objetcGetFromStatutUpdate,
          ...action.payload,
        };
        if (!action.payload.success) {
          state.isStatutUpdatingError = true;
          state.error = action.payload.message;
        }
        // console.log('stut de la session de formation du stagiaire mi a jour :', action.payload);
      })
      .addCase(updateStatut.rejected, (state, action) => {
        state.isStatutUpdating = false;
        state.isStatutUpdatedSuccess = false;
        state.isStatutUpdatingError = true;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log('Erreur lors de la mise a jour du statut:', state.error);
      });

    builder
      .addCase(updateFormationStatut.pending, (state) => {
        state.isFormationStatutUpdating = true;
        state.isFormationStatutUpdatedSuccess = false;
      })
      .addCase(updateFormationStatut.fulfilled, (state, action) => {
        state.isFormationStatutUpdating = false;
        state.isFormationStatutUpdatedSuccess = true;
        state.objetcGetFromStatutUpdate = {
          ...state.objetcGetFromStatutUpdate,
          ...action.payload,
        };
        // console.log('stut de la session de formation  mi a jour :', action.payload);
      })
      .addCase(updateFormationStatut.rejected, (state, action) => {
        state.isFormationStatutUpdating = false;
        state.isFormationStatutUpdatedSuccess = false;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log('Erreur lors de la mise a jour du statut:', state.error);
      });

    builder
      .addCase(archiveFormation.pending, (state) => {
        state.isArchiveFormation = true;
        state.isArchiveFormationSuccess = false;
      })
      .addCase(archiveFormation.fulfilled, (state, action) => {
        state.isArchiveFormation = false;
        state.isArchiveFormationSuccess = true;
        enqueueSnackbar('Formation archivée avec succès !');
        // console.log('formation archiver :', action.payload);
      })
      .addCase(archiveFormation.rejected, (state, action) => {
        state.isArchiveFormation = false;
        state.isArchiveFormationSuccess = false;
        state.error = action?.payload?.data ? action.payload.message : action.error.message;
        // console.log("Erreur lors de l'archivage de la formation:", state.error);
      });
  },
});

const redirect = () => {
  enqueueSnackbar('Intervenant supprimé avec succès !');
  setTimeout(() => {
    window.location.href = paths.contributor;
    resetData();
  }, 50);
};

export const { initFormationsSession, initFormationsSessionReservation, initUpdatingStatut, initDeleteFormationsSession, resetData, resetDataUpdating, resetDataReservationList } = formationsSessionSlice.actions;
export default formationsSessionSlice.reducer;
